import React, { FunctionComponent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import img1 from '../../../../../public/emptyState/optios-empty-state-1.png'
import img2 from '../../../../../public/emptyState/optios-empty-state-2.png'
import img3 from '../../../../../public/emptyState/optios-empty-state-3.png'

import { IProps } from './IProps'
import {
    BackGroundImage,
    Container,
    GuidanceText,
    GuidanceTitle,
} from './style'

const pngArray: string[] = [img1, img2, img3]

export const EmptyState: FunctionComponent<IProps> = ({
    backgroundImage,
    guidance,
}) => {
    const { t } = useTranslation()
    const [imageNumber, setImageNumber] = useState<number>(
        Math.floor(Math.random() * pngArray.length)
    )

    useEffect(() => {
        switch (backgroundImage) {
            case 'pizza':
                setImageNumber(0)
                break
            case 'dog':
                setImageNumber(1)
                break
            case 'search':
                setImageNumber(2)
                break
            default:
                break
        }
    }, [])

    return (
        <Container>
            <BackGroundImage src={pngArray[imageNumber]} />
            <GuidanceTitle>{t('No Content')}</GuidanceTitle>
            <GuidanceText>{guidance}</GuidanceText>
        </Container>
    )
}
